import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { createMap } from './util/Map.js';
import { LevelNode } from './ui/LevelNode.js';
import { Helmet } from 'react-helmet';
import { SearchResults } from './ui/SearchResults';
import Cookies from 'js-cookies';
import { TermsOfUse } from './ui/TermsOfUse';
import { parseUrl } from 'query-string';
import rawRepoContent from './rep_contents.txt';


class Repo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      map: new Map(),
      currentLevelIndex: '1',
      searchValue: '',
      cookieSet: false,
    }
  }

  setCookie(cookieIsSet) {
    this.setState({
      cookieSet: cookieIsSet
    });
  }

  changeLevel(newLevel) {
    if ('' !== newLevel) {
      this.setState({
        currentLevelIndex: newLevel
      });
    }
    window.location.search = '?index=' + newLevel;
  }

  searchChange(event) {
    if (null !== event) {
      this.setSearchValue(event.target.value)
    }
  }


  setSearchValue(newValue) {
    this.setState({
      searchValue: newValue
    });
  }

  loadFile(callback) {
    fetch(rawRepoContent)
      .then(response => response.text())
      .then(text => {
        callback(text);
      })
      .catch(error => console.log(error));

  }

  loadMap(content) {
    let map = createMap(content);
    this.setState({
      map: map,
    });
  }

  componentDidMount() {
    let parsedPath = parseUrl(window.location.href);
    let index = parsedPath.query.index;
    if (!index) {
      index = '1';
    }
    this.setState({
      currentLevelIndex: index,

    });

    /**
     * Load the content file and build the map
     */
    
    this.loadFile((text)=>this.loadMap(text));
  
  }

  render() {
    const level = this.state.currentLevelIndex;
    const map = this.state.map;
    const title = this.state.map.size > 0 ? this.state.map.get('1').title : '';
    const secure = window.location.protocol === 'https';
    const termsOfUseCookie = Cookies.getItem('OA_TOU', { secure: secure });

    return (
      <div>
        {

          '1' === termsOfUseCookie
            ?
            this.state.searchValue.length > 3
              ?
              <div>
                <SearchResults
                  map={map}
                  title={title}
                  onLevelClick={(i) => this.changeLevel(i)}
                  setSearchValue={(i) => this.setSearchValue(i)}
                  searchValue={this.state.searchValue}
                  searchChange={(i) => this.searchChange(i)}
                />
              </div>
              :
              <div>
                <LevelNode
                  level={level}
                  map={map}
                  onLevelClick={(i) => this.changeLevel(i)}
                  searchChange={(i) => this.searchChange(i)}
                  searchValue={this.state.searchValue}
                />
              </div>
            :
            <div>
              <TermsOfUse
                title={title}
                setCookie={(i) => this.setCookie(i)}
              />
            </div>
        }
      </div>
    );
  }

}

ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      <title>Resource Portal</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display&family=Roboto+Condensed&family=Unite&display=swap" rel="stylesheet" />
    </Helmet>
    <Repo
    />
  </React.StrictMode >,
  document.getElementById('root')
);